<template>
  <div class="page">
    <navigation>支持的银行卡</navigation>
    <ul class="content">
      <li v-for="item in list" :key="item.bankCode">
        <img :src="loadBankIcon(item.bankCode)">
        <span>{{item.bankName}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      loanPlatform: this.$route.query.loanPlatform,
      fundCode: this.$route.query.fundCode,
      list: []
    }
  },
  async created () {
    const res = await this.getSupportBankListX({ loanPlatform: this.loanPlatform, fundCode: this.fundCode })
    this.list = res.data
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('bankcard', ['getSupportBankListX']),
    loadBankIcon (bankCode) {
      try {
        return require(`./images/${bankCode.toLowerCase()}.jpg`)
      } catch (e) {}
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
    display: flex;
    flex-direction: column;
    .content {
        flex: 1;
        background-color: #fafafa;
        >li {
            display: flex;
            align-items: center;
            height: 110px;
            background-color: #fff;
            border-bottom: 1px solid #eee;
            padding:  0 30px;
            font-size: 30px;
            color: #333;
            >img {
                width: 60px;
                height: 60px;
                margin-right: 20px;
            }
        }
    }
}
</style>
